var render = function render(_c,_vm){return _c('div',{staticClass:"b2b-grid",class:{
  [_vm.data.staticClass]: _vm.data.staticClass,
  'b2b-grid--fill-height': _vm.props.fillHeight,
}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.data.domProps && _vm.data.domProps.textContent))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }